import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { FieldArray } from 'redux-form'
import { Checkbox, InputDate, Input } from 'components/fields'
import { ElevatedButton } from 'components/layout'
import styles from './training-and-practice-array.styl'

export default class TrainingAndPracticeArray extends Component {
  static propTypes = {
    showDelete: PropTypes.bool,
    showAdd: PropTypes.bool,
    onDeleteItem: PropTypes.func,
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    disableButtons: PropTypes.bool
  }

  static defaultProps = {
    onDeleteItem: () => {},
    showDelete: false,
    showAdd: false
  }

  handleDelete = (fields, index) => {
    fields.remove(index)
    this.props.onDeleteItem(fields.get(index))
  }

  renderFields = ({ fields, meta: { touched, error } }) => {
    const { disabled, disableButtons } = this.props

    return (
      <ul className={styles.list}>
        {fields.map((item, index) => {
          const values = fields.get(index)

          return (
            <li key={index} className={styles.item}>
              {this.props.showAdd ? (
                <Input name={`${item}.name`} type="text" disabled={disabled} />
              ) : (
                <h4 className={styles.heading}>{values.name}</h4>
              )}
              <div className={styles.fields}>
                <div className={styles.date}>
                  <InputDate
                    name={`${item}.date`}
                    disabled={disabled}
                    maxToday
                  />
                </div>
                {this.props.showDelete && (
                  <button
                    className={styles.delete}
                    type="button"
                    onClick={() => this.handleDelete(fields, index)}
                  >
                    <FormattedMessage
                      id="button.delete"
                      defaultMessage="Delete"
                    />
                  </button>
                )}
                <div className={styles.complete}>
                  <Checkbox name={`${item}.isCompleted`} disabled={disabled} />
                </div>
              </div>
            </li>
          )
        })}
        <li>
          {this.props.showAdd &&
            !disabled && (
              <ElevatedButton
                type="button"
                intlKey="button.add_activity"
                onClick={() => fields.push({})}
                secondary
                disabled={disableButtons}
              >
                Add activity
              </ElevatedButton>
            )}
          {touched && error && <span>{error}</span>}
        </li>
      </ul>
    )
  }
  render() {
    const { name } = this.props

    return <FieldArray name={name} component={this.renderFields} />
  }
}
